module.exports = __webpack_public_path__ + "img/comp-myzr.41e9fc65.svg";